/* import __COLOCATED_TEMPLATE__ from './limit-approaching-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    onDismiss: () => void;
  };
}

const LimitApproachingBanner = templateOnlyComponent<Signature>();
export default LimitApproachingBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinUsageGlobalBanners::LimitApproachingBanner': typeof LimitApproachingBanner;
    'fin-usage-global-banners/limit-approaching-banner': typeof LimitApproachingBanner;
  }
}
